import { Appearance, DraftState } from '@/types';
import { getPossiblePrintTypes } from '@/model/configuration/getPossiblePrintTypes';
import { getConfigurations } from '@/model/draft/getConfigurations';
import { changePrintType } from './helper/changePrintType';
import { fixLowContrast } from './helper/fixLowContrast';
import { removeConfiguration } from './helper/removeConfiguration';

export const switchAppearanceAction = (appearance: Appearance) => (draft: DraftState) => {
  getConfigurations(draft).forEach((configuration) => {
    const possiblePrintTypes = getPossiblePrintTypes(
      configuration,
      configuration.printArea,
      appearance
    );
    if (possiblePrintTypes.length === 0) {
      return removeConfiguration(draft, configuration.cid);
    }

    const printType = configuration.printType;
    const printTypeChange = !possiblePrintTypes.find(({ id }) => id === printType.id);
    if (printTypeChange) {
      changePrintType(configuration, possiblePrintTypes[0]);
    }
    fixLowContrast(configuration, appearance, draft);
  });

  draft.appearance = appearance;
};
